// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="october-1-2019">October 1, 2019</h3>
      <p>The Argonaut API was removed and replaced by the <a href="/explore/health/docs/fhir">FHIR Veterans Health API</a></p>
    </div>
  );
};

export default MarkdownComponent;
